import AuthLayout from "../layouts/AuthLayout";
import Register from "../components/Auth/Register";

const RegisterPage = () => {
  return (
    <AuthLayout>
      <Register />
    </AuthLayout>
  );
};

export default RegisterPage;
